/* eslint-disable import/no-unresolved */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { ICONS, MAIN_ICON_COLORS } from './constants';
import UserSettings from './UserSettings';
import QuestionMark from './QuestionMark';
import UserProfile from './UserProfile';
import UserCircle from './UserCircle';
import UserAccount from './UserAccount';
import SecurityShield from './SecurityShield';
import Exchange from './Exchange';
import Shop from './Shop';
import Logout from './Logout';
import AtSymbol from './AtSymbol';
import Paper from './Paper';
import Star from './Star';
import Loading from './Loading';
import Twitter from './Twitter';
import Setting from './Setting';
import Wallet from './Wallet';
import OutlineCard from './OutlineCard';
import Switch from './Switch';
import RedirectMark from './RedirectMark';
import Refresh from './Refresh';
import Light from './Light';
import CardNote from './CardNote';
import Snow from './Snow';
import RightArrow from './RightArrow';
import GlobeLang from './GlobeLang';
import CirclePlus from './CirclePlus';
import CircleMinus from './CircleMinus';
import ConnectIcon from './Connect';

const Icon = ({ icon, color = MAIN_ICON_COLORS?.SHADOW, fillColor = '' }) => {
  const selectedIcon = useMemo(() => {
    switch (icon) {
      case ICONS?.ENVELOPE:
        return (
          <svg
            className="stroke-icon"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <rect x="4" y="6" width="16" height="12" rx="2" stroke={color} strokeWidth="2" />
            <path
              d="M4 9L11.1056 12.5528C11.6686 12.8343 12.3314 12.8343 12.8944 12.5528L20 9"
              stroke={color}
              strokeWidth="2"
            />
          </svg>
        );

      case ICONS.ADDRESS:
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12.398 17.804L12.7894 18.5585H12.7894L12.398 17.804ZM11.602 17.804L11.2106 18.5585H11.2106L11.602 17.804ZM18.15 9C18.15 11.2001 17.0297 13.006 15.6515 14.3962C14.274 15.7856 12.71 16.6846 12.0067 17.0494L12.7894 18.5585C13.569 18.1541 15.306 17.1593 16.8587 15.5931C18.4107 14.0277 19.85 11.8162 19.85 9H18.15ZM12 2.85C15.3966 2.85 18.15 5.60345 18.15 9H19.85C19.85 4.66456 16.3354 1.15 12 1.15V2.85ZM5.85 9C5.85 5.60345 8.60345 2.85 12 2.85V1.15C7.66456 1.15 4.15 4.66456 4.15 9H5.85ZM11.9933 17.0494C11.29 16.6846 9.72597 15.7856 8.34851 14.3962C6.97026 13.006 5.85 11.2001 5.85 9H4.15C4.15 11.8162 5.58926 14.0277 7.14126 15.5931C8.69404 17.1593 10.431 18.1541 11.2106 18.5585L11.9933 17.0494ZM12.0067 17.0494C12.0026 17.0515 12.0003 17.0521 11.9997 17.0523C11.9991 17.0524 11.9993 17.0523 12 17.0523C12.0007 17.0523 12.0009 17.0524 12.0003 17.0523C11.9997 17.0521 11.9974 17.0515 11.9933 17.0494L11.2106 18.5585C11.7088 18.8169 12.2912 18.8169 12.7894 18.5585L12.0067 17.0494ZM14.15 9C14.15 10.1874 13.1874 11.15 12 11.15V12.85C14.1263 12.85 15.85 11.1263 15.85 9H14.15ZM12 6.85C13.1874 6.85 14.15 7.81259 14.15 9H15.85C15.85 6.8737 14.1263 5.15 12 5.15V6.85ZM9.85 9C9.85 7.81259 10.8126 6.85 12 6.85V5.15C9.8737 5.15 8.15 6.8737 8.15 9H9.85ZM12 11.15C10.8126 11.15 9.85 10.1874 9.85 9H8.15C8.15 11.1263 9.8737 12.85 12 12.85V11.15Z"
              fill={color}
            />
            <path
              d="M19.7942 17.5C20.5841 17.9561 21 18.4734 21 19C21 19.5266 20.5841 20.0439 19.7942 20.5C19.0043 20.9561 17.8682 21.3348 16.5 21.5981C15.1318 21.8614 13.5798 22 12 22C10.4202 22 8.86817 21.8614 7.5 21.5981C6.13183 21.3348 4.99569 20.9561 4.20577 20.5C3.41586 20.0439 3 19.5266 3 19C3 18.4734 3.41586 17.9561 4.20577 17.5"
              stroke={color}
              strokeWidth="1.7"
              strokeLinecap="round"
            />
          </svg>
        );
      case ICONS.PHONE:
        return (
          <svg
            width="100%"
            height="100%"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M6.87868 2.87868C6.36902 3.38834 6.17027 4.01669 6.08214 4.67221C5.9999 5.28387 5.99995 6.04768 6 6.93417C6 6.95604 6 6.97798 6 7V17L6 17.0658C5.99995 17.9523 5.9999 18.7161 6.08214 19.3278C6.17027 19.9833 6.36902 20.6117 6.87868 21.1213C7.38834 21.631 8.01669 21.8297 8.67221 21.9179C9.28387 22.0001 10.0477 22.0001 10.9342 22L11 22H13L13.0658 22C13.9523 22.0001 14.7161 22.0001 15.3278 21.9179C15.9833 21.8297 16.6117 21.631 17.1213 21.1213C17.631 20.6117 17.8297 19.9833 17.9179 19.3278C18.0001 18.7161 18.0001 17.9523 18 17.0658L18 17V7L18 6.93417C18.0001 6.04768 18.0001 5.28387 17.9179 4.67221C17.8297 4.01669 17.631 3.38834 17.1213 2.87868C16.6117 2.36902 15.9833 2.17027 15.3278 2.08214C14.7161 1.9999 13.9523 1.99995 13.0658 2C13.044 2 13.022 2 13 2H11C10.978 2 10.956 2 10.9342 2C10.0477 1.99995 9.28387 1.9999 8.67221 2.08214C8.01669 2.17027 7.38834 2.36902 6.87868 2.87868Z"
              stroke={color}
              strokeWidth="2"
            />
            <path d="M7 16H17" stroke={color} strokeWidth="2" />
          </svg>
        );

      case ICONS.USER_PLUS:
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="8" r="4" stroke={color} strokeWidth="2" strokeLinecap="round" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M13.3267 15.0759C12.8886 15.0255 12.4452 15 12 15C10.0805 15 8.19383 15.4738 6.63113 16.3732C5.06902 17.2721 3.88124 18.5702 3.33091 20.1106C3.1451 20.6307 3.41608 21.203 3.93617 21.3888C4.45626 21.5746 5.02851 21.3036 5.21432 20.7835C5.57558 19.7723 6.39653 18.8157 7.62872 18.1066C8.64273 17.523 9.86375 17.1503 11.158 17.0368C11.4889 16.0601 12.3091 15.3092 13.3267 15.0759Z"
              fill={color}
            />
            <path d="M18 14L18 22" stroke={color} strokeWidth="2.5" strokeLinecap="round" />
            <path d="M22 18L14 18" stroke={color} strokeWidth="2.5" strokeLinecap="round" />
          </svg>
        );

      case ICONS.SCAN:
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M20 10L20 9C20 8.07003 20 7.60504 19.8978 7.22354C19.6204 6.18827 18.8117 5.37962 17.7765 5.10222C17.395 5 16.93 5 16 5"
              stroke={color}
              strokeWidth="2"
              strokeLinejoin="round"
            />
            <path
              d="M20 14L20 15C20 15.93 20 16.395 19.8978 16.7765C19.6204 17.8117 18.8117 18.6204 17.7765 18.8978C17.395 19 16.93 19 16 19"
              stroke={color}
              strokeWidth="2"
              strokeLinejoin="round"
            />
            <path
              d="M10 19L9 19C7.13077 19 6.19615 19 5.5 18.5981C5.04394 18.3348 4.66523 17.9561 4.40192 17.5C4 16.8038 4 15.8692 4 14"
              stroke={color}
              strokeWidth="2"
              strokeLinejoin="round"
            />
            <path
              d="M10 5L9 5C7.13077 5 6.19615 5 5.5 5.40192C5.04394 5.66523 4.66523 6.04394 4.40192 6.5C4 7.19615 4 8.13077 4 10"
              stroke={color}
              strokeWidth="2"
              strokeLinejoin="round"
            />
            <path
              d="M10 21L10 3"
              stroke={color}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      case ICONS.INTERNATIONAL:
        return (
          <svg
            width="25"
            height="22"
            viewBox="0 0 25 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M3.41838 11.5067L4.2296 12.3179L5.09027 11.4572L3.38871 9.75568L3.36892 9.73589L2.79514 9.16211L2.21146 9.74084L2.20157 9.75073L0.5 11.4523L1.36068 12.313L2.19662 11.477C2.32028 14.1283 3.44806 16.5224 5.20899 18.2833C7.07378 20.1481 9.65581 21.3056 12.4951 21.3056H13.1035V20.0838H12.4951C7.65251 20.0887 3.68549 16.2849 3.41838 11.5067Z"
              fill={color}
            />
            <path
              d="M23.6393 9.68594L22.8033 10.5219C22.6797 7.87061 21.5519 5.47654 19.791 3.71562C17.9262 1.85082 15.3491 0.693359 12.5049 0.693359H11.8965V1.91512H12.5049C17.3474 1.91512 21.3145 5.71892 21.5816 10.4972L20.7704 9.68594L19.9097 10.5466L21.6112 12.2482L21.631 12.268L22.2048 12.8418L22.7885 12.2581L22.7984 12.2482L24.4999 10.5466L23.6393 9.68594Z"
              fill={color}
            />
            <path
              d="M12.5 5.07031C9.23039 5.07031 6.56921 7.73148 6.56921 11.0011C6.56921 14.2706 9.23039 16.9318 12.5 16.9318C15.7695 16.9318 18.4307 14.2706 18.4307 11.0011C18.4307 7.73148 15.7695 5.07031 12.5 5.07031ZM10.7489 6.945C10.3878 7.44954 10.0367 8.08268 9.79922 8.86421H8.63187C9.10672 8.01343 9.84869 7.33082 10.7489 6.945ZM8.26089 12.2575C8.14217 11.8617 8.07787 11.4413 8.07787 11.006C8.07787 10.5707 8.14217 10.1503 8.26089 9.75457H9.59147C9.52717 10.1453 9.4876 10.5608 9.4876 11.006C9.4876 11.4512 9.52717 11.8716 9.59147 12.2575H8.26089ZM8.63187 13.1429H9.79922C10.0367 13.9194 10.3878 14.5575 10.7489 15.0621C9.84869 14.6713 9.10672 13.9936 8.63187 13.1429ZM12.0548 15.2302C11.6244 14.795 11.0902 14.1124 10.739 13.1429H12.0548V15.2302ZM12.0548 12.2575H10.4967C10.4225 11.8716 10.378 11.4561 10.378 11.006C10.378 10.5509 10.4225 10.1354 10.4967 9.75457H12.0548V12.2575ZM12.0548 8.85927H10.7341C11.0853 7.88482 11.6244 7.19727 12.0548 6.76693V8.85927ZM16.3631 8.85927H15.1958C14.9583 8.08268 14.6071 7.44459 14.246 6.94006C15.1463 7.33082 15.8932 8.01343 16.3631 8.85927ZM12.9402 6.77683C13.3705 7.21211 13.9047 7.89471 14.2559 8.86421H12.9402V6.77683ZM12.9402 9.74962H14.4983C14.5725 10.1354 14.617 10.5509 14.617 11.0011C14.617 11.4561 14.5725 11.8716 14.4983 12.2525H12.9352V9.74962H12.9402ZM12.9402 13.1429H14.2609C13.9097 14.1173 13.3705 14.8049 12.9402 15.2352V13.1429ZM14.246 15.0621C14.6071 14.5575 14.9583 13.9244 15.1958 13.1429H16.3631C15.8932 13.9936 15.1463 14.6713 14.246 15.0621ZM16.9171 11.0011C16.9171 11.4363 16.8528 11.8568 16.7341 12.2525H15.4035C15.4678 11.8617 15.5074 11.4462 15.5074 11.0011C15.5074 10.5559 15.4678 10.1354 15.4035 9.74962H16.7341C16.8528 10.1453 16.9171 10.5658 16.9171 11.0011Z"
              fill={color}
            />
          </svg>
        );

      case ICONS.USA:
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_36849_243828)">
              <path
                d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
                fill="#F0F0F0"
              />
              <path
                d="M11.4783 12.0015H24C24 10.9185 23.8556 9.8692 23.5866 8.87109H11.4783V12.0015Z"
                fill="#D80027"
              />
              <path
                d="M11.4783 5.73983H22.2387C21.5041 4.54114 20.5649 3.48162 19.4698 2.60938H11.4783V5.73983Z"
                fill="#D80027"
              />
              <path
                d="M12 24.0013C14.8241 24.0013 17.4199 23.0251 19.4698 21.3926H4.53015C6.58 23.0251 9.17579 24.0013 12 24.0013Z"
                fill="#D80027"
              />
              <path
                d="M1.76122 18.2613H22.2387C22.8284 17.299 23.2857 16.2471 23.5865 15.1309H0.41333C0.714127 16.2471 1.17149 17.299 1.76122 18.2613Z"
                fill="#D80027"
              />
              <path
                d="M5.55863 1.87397H6.65217L5.63498 2.61295L6.02353 3.80869L5.00639 3.0697L3.98925 3.80869L4.32487 2.7757C3.42928 3.52172 2.64431 4.39575 1.99744 5.36963H2.34783L1.70034 5.84002C1.59947 6.0083 1.50272 6.17925 1.41 6.35273L1.71919 7.30434L1.14234 6.88523C0.998953 7.18903 0.867797 7.49967 0.749906 7.81678L1.09055 8.86528H2.34783L1.33064 9.60427L1.71919 10.8L0.702047 10.061L0.0927656 10.5037C0.0317812 10.9939 0 11.4932 0 12H12C12 5.37262 12 4.59131 12 0C9.62944 0 7.41961 0.687656 5.55863 1.87397ZM6.02353 10.8L5.00639 10.061L3.98925 10.8L4.3778 9.60427L3.36061 8.86528H4.61789L5.00639 7.66955L5.39489 8.86528H6.65217L5.63498 9.60427L6.02353 10.8ZM5.63498 6.10861L6.02353 7.30434L5.00639 6.56536L3.98925 7.30434L4.3778 6.10861L3.36061 5.36963H4.61789L5.00639 4.17389L5.39489 5.36963H6.65217L5.63498 6.10861ZM10.3279 10.8L9.31073 10.061L8.29359 10.8L8.68214 9.60427L7.66495 8.86528H8.92223L9.31073 7.66955L9.69923 8.86528H10.9565L9.93933 9.60427L10.3279 10.8ZM9.93933 6.10861L10.3279 7.30434L9.31073 6.56536L8.29359 7.30434L8.68214 6.10861L7.66495 5.36963H8.92223L9.31073 4.17389L9.69923 5.36963H10.9565L9.93933 6.10861ZM9.93933 2.61295L10.3279 3.80869L9.31073 3.0697L8.29359 3.80869L8.68214 2.61295L7.66495 1.87397H8.92223L9.31073 0.678234L9.69923 1.87397H10.9565L9.93933 2.61295Z"
                fill="#0052B4"
              />
            </g>
            <defs>
              <clipPath id="clip0_36849_243828">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
        );
      case ICONS.CHECK:
        return (
          <svg
            width="100%"
            height="100%"
            viewBox="0 0 14 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12.5287 0.861666L4.99999 8.39033L2.22132 5.61167C1.59266 4.983 0.649991 5.92567 1.27866 6.555L4.52866 9.805C4.65263 9.93298 4.82187 10.0072 4.99999 10.0117C5.17799 10.0097 5.34666 9.929 5.47133 9.80433L13.4713 1.80433C14.1 1.17567 13.1573 0.232999 12.5287 0.861666Z"
              fill={color}
              stroke={color}
              strokeWidth="0.5"
            />
          </svg>
        );

      case ICONS.KEY:
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_42122_23267)">
              <path
                d="M20.3961 2.00195H17.6874C17.1572 2.00523 16.6497 2.21737 16.2748 2.59239L9.73863 9.12854C9.32976 9.04786 8.91403 9.00733 8.49728 9.00751C6.77582 9.01102 5.12587 9.6964 3.90861 10.9137C2.69136 12.1309 2.00595 13.7809 2.00244 15.5023C2.00595 17.2238 2.69136 18.8737 3.90861 20.091C5.12587 21.3082 6.77582 21.9936 8.49728 21.9971C10.2187 21.9936 11.8687 21.3082 13.0859 20.091C14.3032 18.8737 14.9886 17.2238 14.9921 15.5023C14.9922 15.088 14.9516 14.6747 14.871 14.2683L16.2808 12.8586C16.6558 12.4844 16.868 11.9773 16.8712 11.4475V10.4275H17.714C18.1382 10.4267 18.5447 10.2579 18.8446 9.95798C19.1445 9.65807 19.3133 9.25154 19.3141 8.82741V7.36461H20.3961C20.8202 7.36422 21.2269 7.19576 21.5271 6.89613C21.8273 6.5965 21.9965 6.19012 21.9977 5.76599V3.60203C21.9969 3.17765 21.8278 2.77089 21.5276 2.47094C21.2274 2.171 20.8205 2.00234 20.3961 2.00195ZM19.9961 5.3645H18.9111C18.4871 5.36528 18.0807 5.53416 17.7811 5.8341C17.4814 6.13405 17.3129 6.54059 17.3125 6.96458V8.42739H16.4697C16.0455 8.42817 15.639 8.597 15.3391 8.89691C15.0392 9.19681 14.8704 9.60334 14.8696 10.0275V11.4445L12.6451 13.669L12.8104 14.2373C12.9317 14.6481 12.9938 15.074 12.9949 15.5023C12.9937 16.6953 12.5194 17.8392 11.6759 18.6829C10.8325 19.5266 9.68879 20.0014 8.49577 20.0029C7.30261 20.0014 6.15878 19.5267 5.31509 18.683C4.4714 17.8393 3.99674 16.6955 3.99518 15.5023C3.99674 14.3093 4.47143 13.1656 5.31516 12.3221C6.1589 11.4787 7.30274 11.0043 8.49577 11.0032C8.92554 11.0039 9.35301 11.0661 9.76523 11.1877L10.3335 11.356L17.686 4.00207H19.9946L19.9961 5.3645Z"
                fill={color}
              />
              <path
                d="M6.48674 15.3841C6.34744 15.5234 6.23692 15.6887 6.16153 15.8707C6.08614 16.0527 6.04736 16.2477 6.04736 16.4447C6.04736 16.6417 6.08614 16.8367 6.16153 17.0187C6.23692 17.2007 6.34744 17.366 6.48674 17.5053C6.626 17.6446 6.79134 17.7551 6.97332 17.8305C7.1553 17.9059 7.35036 17.9447 7.54733 17.9447C7.74431 17.9447 7.93937 17.9059 8.12134 17.8305C8.30332 17.7551 8.46866 17.6446 8.60793 17.5053C8.74723 17.366 8.85767 17.2007 8.93306 17.0187C9.00845 16.8367 9.0473 16.6417 9.0473 16.4447C9.0473 16.2477 9.00845 16.0527 8.93306 15.8707C8.85767 15.6887 8.74723 15.5234 8.60793 15.3841C8.32647 15.1031 7.94502 14.9453 7.54733 14.9453C7.14964 14.9453 6.76819 15.1031 6.48674 15.3841Z"
                fill={color}
              />
            </g>
            <defs>
              <clipPath id="clip0_42122_23267">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
        );

      case ICONS.SHIELD:
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M11.3102 14.3678C11.1353 14.3668 10.9625 14.3296 10.8027 14.2585C10.6429 14.1873 10.4995 14.0838 10.3818 13.9545L8.42741 11.8053C8.24928 11.6088 8.15639 11.3498 8.16912 11.0849C8.18186 10.82 8.29915 10.571 8.4953 10.3926C8.59247 10.3042 8.70612 10.2359 8.82973 10.1915C8.95334 10.147 9.08449 10.1274 9.21569 10.1337C9.34689 10.14 9.47556 10.1721 9.59434 10.2282C9.71312 10.2843 9.81969 10.3632 9.90794 10.4605L11.3147 12.006L14.5798 8.39987C14.6678 8.30237 14.7742 8.22319 14.8929 8.16685C15.0116 8.11051 15.1402 8.07815 15.2714 8.07157C15.4026 8.06499 15.5338 8.08433 15.6576 8.12851C15.7813 8.17269 15.8951 8.24082 15.9924 8.32902C16.0898 8.41717 16.1689 8.52364 16.2251 8.64237C16.2813 8.7611 16.3136 8.88974 16.32 9.02095C16.3264 9.15215 16.3069 9.28335 16.2626 9.40702C16.2183 9.53068 16.1501 9.6444 16.0618 9.74166L12.249 13.9545C12.1298 14.0847 11.9847 14.1888 11.8231 14.2599C11.6615 14.3311 11.4868 14.3678 11.3102 14.3678Z"
              fill={color}
            />
            <path
              d="M11.9996 21.9996C11.1875 21.9995 10.3939 21.7569 9.72053 21.3029C7.43405 19.7693 3.59766 16.5528 3.59766 12.2515V7.41579C3.59888 6.69965 3.78826 5.9964 4.1468 5.37647C4.50534 4.75654 5.02047 4.2417 5.6406 3.8835C7.12851 3.02441 9.44154 2 11.9996 2C14.5577 2 16.8708 3.02441 18.3602 3.8835C18.9798 4.24212 19.4945 4.75707 19.8527 5.37693C20.211 5.9968 20.4003 6.69985 20.4016 7.41579V12.2515C20.4016 16.5528 16.5638 19.7693 14.2788 21.3029C13.6052 21.7567 12.8117 21.9992 11.9996 21.9996ZM10.835 19.6379C11.1795 19.8695 11.5852 19.9932 12.0004 19.9932C12.4155 19.9932 12.8213 19.8695 13.1658 19.6379C15.1201 18.3256 18.4015 15.6199 18.4015 12.2471V7.41136C18.4007 7.0466 18.3041 6.68844 18.1215 6.37269C17.9389 6.05693 17.6766 5.79464 17.3608 5.61201C16.0825 4.87396 14.1134 3.99569 11.9996 3.99569C9.88584 3.99569 7.91675 4.87396 6.63844 5.61201C6.32407 5.79557 6.06326 6.05826 5.88198 6.37395C5.70069 6.68964 5.60526 7.04732 5.60517 7.41136V12.2471C5.60517 15.6199 8.88655 18.3256 10.8424 19.6379H10.835Z"
              fill={color}
            />
          </svg>
        );
      case ICONS.CLIPBOARD:
        return (
          <svg
            width="17"
            height="20"
            viewBox="0 0 17 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M13.4737 17.4737C13.4737 18.1437 13.2075 18.7863 12.7337 19.2601C12.26 19.7338 11.6174 20 10.9474 20H2.52632C1.8563 20 1.21372 19.7338 0.739941 19.2601C0.266165 18.7863 0 18.1437 0 17.4737V5.68421C0 5.01419 0.266165 4.37161 0.739941 3.89784C1.21372 3.42406 1.8563 3.15789 2.52632 3.15789V4.84211C2.30298 4.84211 2.08878 4.93083 1.93086 5.08875C1.77293 5.24668 1.68421 5.46087 1.68421 5.68421V17.4737C1.68421 17.697 1.77293 17.9112 1.93086 18.0691C2.08878 18.2271 2.30298 18.3158 2.52632 18.3158H10.9474C11.1707 18.3158 11.3849 18.2271 11.5428 18.0691C11.7008 17.9112 11.7895 17.697 11.7895 17.4737H13.4737Z"
              fill={color}
            />
            <path
              d="M16.6316 5.84421C16.6228 5.76685 16.6059 5.69064 16.5811 5.61684V5.54105C16.5406 5.45447 16.4866 5.37488 16.4211 5.30526L11.3684 0.252632C11.2988 0.187129 11.2192 0.133121 11.1326 0.0926315H11.0568C10.9713 0.0435716 10.8768 0.0120793 10.7789 0H5.68421C5.01419 0 4.37161 0.266165 3.89784 0.739941C3.42406 1.21372 3.15789 1.8563 3.15789 2.52632V14.3158C3.15789 14.9858 3.42406 15.6284 3.89784 16.1022C4.37161 16.5759 5.01419 16.8421 5.68421 16.8421H14.1053C14.7753 16.8421 15.4179 16.5759 15.8916 16.1022C16.3654 15.6284 16.6316 14.9858 16.6316 14.3158V5.89474C16.6316 5.89474 16.6316 5.89474 16.6316 5.84421ZM11.5789 2.87158L13.76 5.05263H12.4211C12.1977 5.05263 11.9835 4.96391 11.8256 4.80598C11.6677 4.64806 11.5789 4.43387 11.5789 4.21053V2.87158ZM14.9474 14.3158C14.9474 14.5391 14.8586 14.7533 14.7007 14.9112C14.5428 15.0692 14.3286 15.1579 14.1053 15.1579H5.68421C5.46087 15.1579 5.24668 15.0692 5.08875 14.9112C4.93083 14.7533 4.84211 14.5391 4.84211 14.3158V2.52632C4.84211 2.30298 4.93083 2.08878 5.08875 1.93086C5.24668 1.77293 5.46087 1.68421 5.68421 1.68421H9.89474V4.21053C9.89474 4.88055 10.1609 5.52313 10.6347 5.9969C11.1085 6.47068 11.751 6.73684 12.4211 6.73684H14.9474V14.3158Z"
              fill={color}
            />
          </svg>
        );

      case ICONS.FITLER:
        return (
          <svg
            width="100%"
            height="100%"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M9.65811 19.7806L9.97433 20.7293H9.97433L9.65811 19.7806ZM14.6581 18.114L14.9743 19.0627L14.9743 19.0626L14.6581 18.114ZM19.7071 7.29289L20.4142 8L19.7071 7.29289ZM15.2929 11.7071L14.5858 11L15.2929 11.7071ZM5 5H19V3H5V5ZM5 6.58579V5H3V6.58579H5ZM9.41421 11L5 6.58579L3.58579 8L7.99999 12.4142L9.41421 11ZM7.99999 12.4142V19.3063H9.99999V12.4142H7.99999ZM7.99999 19.3063C7.99999 20.3301 9.00304 21.0531 9.97433 20.7293L9.34188 18.832C9.66565 18.724 9.99999 18.965 9.99999 19.3063H7.99999ZM9.97433 20.7293L14.9743 19.0627L14.3419 17.1653L9.34188 18.832L9.97433 20.7293ZM14.9743 19.0626C15.5868 18.8585 16 18.2853 16 17.6396H14C14 17.4244 14.1377 17.2333 14.3419 17.1653L14.9743 19.0626ZM16 17.6396V12.4142H14V17.6396H16ZM19 6.58579L14.5858 11L16 12.4142L20.4142 8L19 6.58579ZM19 5V6.58579H21V5H19ZM20.4142 8C20.7893 7.62493 21 7.11622 21 6.58579H19L20.4142 8ZM16 12.4142V12.4142L14.5858 11C14.2107 11.3751 14 11.8838 14 12.4142H16ZM7.99999 12.4142H9.99999C9.99999 11.8838 9.78928 11.3751 9.41421 11L7.99999 12.4142ZM3 6.58579C3 7.11622 3.21071 7.62493 3.58579 8L5 6.58579V6.58579H3ZM19 5H21C21 3.89543 20.1046 3 19 3V5ZM5 3C3.89543 3 3 3.89543 3 5H5V5V3Z"
              fill={color}
            />
          </svg>
        );

      case ICONS.FILLED_FILTER:
        return (
          <svg
            width="100%"
            height="100%"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M5 2C4.44772 2 4 2.44772 4 3V5.00001H20V3C20 2.44772 19.5523 2 19 2H5ZM19.7822 7.00001H4.21776C4.3321 7.22455 4.48907 7.42794 4.68299 7.59762L10.683 12.8476C11.437 13.5074 12.563 13.5074 13.317 12.8476L19.317 7.59762C19.5109 7.42794 19.6679 7.22455 19.7822 7.00001Z"
              fill={color}
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M14 16.2639L14 10H10V18.2639L14 16.2639ZM14 20.7361L13.4721 21H14V20.7361Z"
              fill={color}
            />
          </svg>
        );

      case ICONS.CALENDAR:
        return (
          <svg
            width="100%"
            height="100%"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <rect x="3" y="6" width="18" height="15" rx="2" stroke={color} strokeWidth="2" />
            <path
              d="M3 10C3 8.11438 3 7.17157 3.58579 6.58579C4.17157 6 5.11438 6 7 6H17C18.8856 6 19.8284 6 20.4142 6.58579C21 7.17157 21 8.11438 21 10H3Z"
              fill={color}
            />
            <path d="M7 3L7 6" stroke={color} strokeWidth="2" strokeLinecap="round" />
            <path d="M17 3L17 6" stroke={color} strokeWidth="2" strokeLinecap="round" />
          </svg>
        );

      case ICONS.FILLED_CALENDAR:
        return (
          <svg
            width="100%"
            height="100%"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M2 9C2 7.11438 2 6.17157 2.58579 5.58579C3.17157 5 4.11438 5 6 5H18C19.8856 5 20.8284 5 21.4142 5.58579C22 6.17157 22 7.11438 22 9C22 9.4714 22 9.70711 21.8536 9.85355C21.7071 10 21.4714 10 21 10H3C2.5286 10 2.29289 10 2.14645 9.85355C2 9.70711 2 9.4714 2 9Z"
              fill={color}
            />
            <path
              d="M2 18C2 19.8856 2 20.8284 2.58579 21.4142C3.17157 22 4.11438 22 6 22H18C19.8856 22 20.8284 22 21.4142 21.4142C22 20.8284 22 19.8856 22 18V13C22 12.5286 22 12.2929 21.8536 12.1464C21.7071 12 21.4714 12 21 12H3C2.5286 12 2.29289 12 2.14645 12.1464C2 12.2929 2 12.5286 2 13V18Z"
              fill={color}
            />
            <path d="M7 3L7 6" stroke={color} strokeWidth="2" strokeLinecap="round" />
            <path d="M17 3L17 6" stroke={color} strokeWidth="2" strokeLinecap="round" />
          </svg>
        );

      case ICONS.CRYPTODRAFT:
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 36 36"
            fill={fillColor}
            xmlns="http://www.w3.org/2000/svg">
            <rect width="36" height="36" rx="18" fill={fillColor} />
            <path
              d="M13.208 22.1711C13.5147 22.6881 13.8929 23.163 14.3337 23.5809C15.2511 24.4504 16.4009 25.0355 17.6439 25.2653C18.8869 25.4951 20.1699 25.3598 21.3376 24.8757C22.5053 24.3916 23.5077 23.5796 24.2235 22.5377C24.9394 21.4959 25.338 20.2689 25.3711 19.0053C25.4042 17.7416 25.0704 16.4955 24.4102 15.4176C23.7499 14.3397 22.7914 13.4762 21.6507 12.9316C20.7911 12.5212 19.8557 12.3052 18.9106 12.2939L19.295 13.7285C19.898 13.7831 20.4896 13.9443 21.0414 14.2078C21.9355 14.6346 22.6868 15.3114 23.2043 16.1562C23.7218 17.0011 23.9834 17.9778 23.9574 18.9682C23.9315 19.9586 23.6191 20.9203 23.058 21.7369C22.4969 22.5535 21.7113 23.19 20.796 23.5694C19.8808 23.9488 18.8752 24.0548 17.901 23.8747C16.9268 23.6946 16.0256 23.236 15.3065 22.5545C15.0592 22.3201 14.837 22.0627 14.6426 21.7867L13.208 22.1711Z"
              fill={color}
            />
            <path
              d="M13.7603 12.2221C14.3634 11.7593 15.0258 11.3821 15.7284 11.1C16.1403 10.9346 16.3463 10.852 16.5475 10.9525C16.7486 11.0531 16.8109 11.2854 16.9353 11.7499L18.5745 17.8674C18.6965 18.3227 18.7575 18.5504 18.654 18.7298C18.5504 18.9091 18.3227 18.9701 17.8674 19.0922L11.7499 20.7313C11.2854 20.8558 11.0531 20.918 10.8654 20.7941C10.6777 20.6702 10.6464 20.4505 10.5836 20.011C10.4766 19.2615 10.4721 18.4993 10.5713 17.7456C10.7141 16.6606 11.0693 15.6144 11.6165 14.6667C12.1636 13.7189 12.8921 12.8883 13.7603 12.2221Z"
              stroke={color}
              strokeWidth="1.5"
            />
          </svg>
        );

      case ICONS.SETTING:
        return <Setting color={color} />;

      case ICONS.USER_SETTINGS:
        return <UserSettings color={color} />;

      case ICONS.QUESTION_MARK:
        return <QuestionMark color={color} />;

      case ICONS.USER_PROFILE:
        return <UserProfile color={color} />;

      case ICONS.USER_CIRCLE:
        return <UserCircle color={color} />;

      case ICONS.USER_ACCOUNT:
        return <UserAccount color={color} />;

      case ICONS.EXCHANGE:
        return <Exchange color={color} />;

      case ICONS.SECURITY_SHIELD:
        return <SecurityShield color={color} />;

      case ICONS.SHOP:
        return <Shop color={color} />;

      case ICONS.LOGOUT:
        return <Logout color={color} />;

      case ICONS.AT_SYMBOL:
        return <AtSymbol color={color} />;

      case ICONS.PAPER:
        return <Paper color={color} />;

      case ICONS.STAR:
        return <Star color={color} />;

      case ICONS.LOADING:
        return <Loading color={color} />;

      case ICONS.TWITTER:
        return <Twitter color={color} />;

      case ICONS.WALLET:
        return <Wallet color={color} />;

      case ICONS.SWITCH:
        return <Switch color={color} />;
      case ICONS.OUTLINE_CARD:
        return <OutlineCard color={color} />;

      case ICONS.REDIRECT_MARK:
        return <RedirectMark color={color} />;

      case ICONS.REFRESH:
        return <Refresh color={color} />;

      case ICONS.LIGHT:
        return <Light color={color} />;

      case ICONS.CARD_NOTE:
        return <CardNote color={color} />;
      case ICONS.RIGHT_ARROW:
        return <RightArrow color={color} />;

      case ICONS.SNOW:
        return <Snow color={color} />;

      case ICONS.GLOBE_LANG:
        return <GlobeLang color={color} />;

      case ICONS.CIRCLE_PLUS:
        return <CirclePlus color={color} />;

      case ICONS.CIRCLE_MINUS:
        return <CircleMinus color={color} />;

      case ICONS.CONNECT:
        return <ConnectIcon color={color} />;

      default:
        return <></>;
    }
  }, [icon, color, fillColor]);

  return selectedIcon;
};

export default Icon;

Icon.propTypes = {
  icon: PropTypes.string.isRequired,
  color: PropTypes.string,
  fillColor: PropTypes.string,
};
